(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restromart-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('restromart-banner-carousel')) {
    customElements.define('restromart-banner-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide-index]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot-index]'));
        this.index = 0;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dotIndex))));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      show(nextIndex) {
        if (!this.slides.length) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      }
      start() {
        this.stop();
        if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.timer = window.setInterval(() => this.show(this.index + 1), Number(this.dataset.delay) || 6000);
        }
      }
      stop() { window.clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restromart-contact-form"] && !Shopify.designMode) return;
  try {
    
  function restromartPrefillSkid() {
    const parameters = new URLSearchParams(window.location.search);
    if (parameters.get('enquiry') !== 'skid') return;
    const message = document.querySelector('[data-rm-skid-message]');
    const product = parameters.get('product');
    if (!message || !product || message.value.trim()) return;
    message.value = message.dataset.rmSkidMessage + '\n' + product.slice(0, 500) + '\n\n' + message.dataset.rmSkidQuantity + '\n' + message.dataset.rmSkidDelivery;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restromartPrefillSkid, { once: true });
  else restromartPrefillSkid();
  document.addEventListener('shopify:section:load', restromartPrefillSkid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restromart-welcome-offer"]) return;
  try {
    
  (() => {
    const dialog = document.currentScript?.previousElementSibling?.matches('[data-rm-welcome-offer]')
      ? document.currentScript.previousElementSibling
      : document.querySelector('[data-rm-welcome-offer]');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const key = 'restromart:welcome-offer-dismissed';
    const frequency = Math.max(1, Number(dialog.dataset.frequency) || 7) * 86400000;
    let lastDismissed = 0;
    try { lastDismissed = Number(localStorage.getItem(key)) || 0; } catch { lastDismissed = 0; }
    const close = () => {
      try { localStorage.setItem(key, String(Date.now())); } catch {}
      if (dialog.open) dialog.close();
    };
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-rm-offer-close]')) close();
    });
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    if (Date.now() - lastDismissed >= frequency) {
      window.setTimeout(() => { if (dialog.isConnected && !dialog.open) dialog.showModal(); }, Number(dialog.dataset.delay) || 1500);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
